<template>
  <b-card class="bg-white">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('ffc-partner')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">Add FFC Partner</h2>
    </div>

    <!-- <validation-observer v-slot="{ handleSubmit }" ref="formValidator"> -->
    <b-form role="form">
      <base-input
        alternative
        class="mb-3"
        name="Title"
        :rules="{ required: true }"
        placeholder="Title"
        v-model="title"
      >
      </base-input>

      <base-input
        alternative
        class="mb-3"
        name="Social Link"
        :rules="{}"
        placeholder="Social Link"
        v-model="link"
      >
      </base-input>

      <!-- <quill-editor
          v-model="description"
          :options="editorOption"
          class="quill-h200px my-2"
        /> -->

      <div
        class="text-sm text-gray-600 font-medium px-2 py-1 mb-1 border rounded bg-gray-100 inline-block"
      >
        Recommended Size: 180 × 90px
      </div>
      <FileUploader v-show="!image" :image="image" :onSuccess="handleSuccess" />

      <div class="flex cursor-pointer items-center my-2" v-if="image">
        <base-button type="danger" class="px-8" @click="handleRemove">
          Remove image
        </base-button>
      </div>
      <span v-if="imageErr" class="small text-danger">{{ msg.image }}</span>
      <img v-if="image" :src="image" ref="cover" />
      <base-button
        type="primary"
        outline
        class="w-full my-2"
        native-type="submit"
        @click="onSubmit()"
        >Create</base-button
      >
    </b-form>
    <!-- </validation-observer> -->
  </b-card>
</template>

<script>
import FileUploader from "./components/FileUploader.vue";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { mapState } from "vuex";
import _ from "lodash";

export default {
  components: {
    FileUploader,
    quillEditor,
  },
  data() {
    return {
      title: "",
      image: null,
      link: "",
      coverImage: null,
      description: "",
      selected: [],

      editorOption: {
        theme: "snow",
      },
      imageErr: false,
      msg: {},
      options: [],
    };
  },

  methods: {
    handleSuccess(image) {
      let mByte = 5 * 1048576;
      this.imageErr = false;
      if (!image.type.includes("image")) {
        this.imageErr = true;
        this.msg.image = "Upload Image Only";
      } else {
        this.imageErr = false;
        if (image.size > mByte) {
          this.$swal.fire({
            title: "File size exceeds the allowed limit!",
            // text: "Please ensure that the file size does not exceed 5MB",
            html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          return;
        }
        this.coverImage = image;
        this.readerData(image);
      }
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    async onSubmit() {
      let loader = this.$loading();
      if (!this.coverImage) {
        this.$swal.fire({
          text: "Please Select Image or Upload SVG Image only",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        loader.close();
        return;
      }
      let data = new FormData();
      data.append("title", this.title);
      data.append("description", this.description);
      data.append("link", this.link);
      data.append("image", this.coverImage);

      try {
        const blogdata = await this.$store.dispatch("ffc/add_partner", data);
        if (blogdata.code == 200) {
          loader.close();
          this.$swal
            .fire({
              text: "Partner Added Successfully",
              icon: "success",
              confirmButtonText: "Okay",
              confirmButtonColor: "#830c81",
              timer: 3000,
              showCancelButton: false,
            })
            .then(() => this.$router.push("/admin/ffc-partner"));
        }
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },

    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
  async mounted() {
    if (window.location.pathname !== "/admin/ffc-partner") {
      window.history.replaceState({}, "", "/admin/ffc-partner");
    }
    // await this.$store.dispatch("services/get_all");
    // this.get_AllService.forEach((x) => {
    //   const array = this.options.push({
    //     text: x.title,
    //     _id: x._id,
    //   });
    // });
    // console.log(this.get_AllService);
  },
  computed: {
    ...mapState("ffc", { ffc_partner: "ffc_partner" }),
  },
};
</script>
